import { styled, Typography } from '@mui/material'

import { getIsActiveStatusColor } from 'utils'

export const StateVisualizer = styled(Typography)<{ state: boolean }>(({ theme, state }) => ({
  width: 80,
  textAlign: 'center',
  display: 'inline-block',
  padding: theme.spacing(0.3),
  margin: theme.spacing(0),
  backgroundColor: getIsActiveStatusColor(state, theme.palette.mode),
  color: theme.palette.getContrastText(getIsActiveStatusColor(state, theme.palette.mode)),
  borderRadius: theme.shape.borderRadius,
}))
